export default ({ multiple = false, defaultOpen = [] } = {}) => ({
    openItems: Array.isArray(defaultOpen) ? defaultOpen : [defaultOpen],
  
    isOpen(id) {
      return this.openItems.includes(id);
    },
  
    toggle(id) {
      if (this.isOpen(id)) {
        this.openItems = this.openItems.filter((item) => item !== id);
        return;
      }
  
      if (multiple) {
        this.openItems = [...this.openItems, id];
        return;
      }
  
      this.openItems = [id];
    },
  });